<template>
  <div class="applicationType div-layout">
    <div class="applicationType-main">
      <div class="applicationType-main-contain">
        <div class="applicationType-list">
          <el-form
            ref="searchForm"
            class="searchForm"
            :model="searchForm"
            :inline="true"
            label-position="right"
            label-width="100px"
            @submit.native.prevent
          >
            <el-form-item label="" prop="name">
              <el-input
                v-model="searchForm.name"
                maxlength="10"
                name="name"
                size="medium"
                style="width:250px"
                placeholder="请输入类型名称"
                class="handle-form-input"
                @keyup.enter.native="handleSearchFilter"
              />
            </el-form-item>
            <el-form-item style="margin-left:15px;">
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
            <el-button
              class="add-type"
              type="primary"
              size="medium"
              icon="el-icon-plus"
              @click="opAddOrEdit('add')"
            >
              新增类型
            </el-button>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="apptypesList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="类型名称" prop="name" align="center" show-overflow-tooltip />
            <el-table-column label="类型简介" prop="introduction" align="center" show-overflow-tooltip />
            <el-table-column label="最后编辑时间" prop="updateDate" align="center" show-overflow-tooltip />
            <el-table-column label="操作" align="left" width="300px" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="opAddOrEdit('edit',scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="danger"
                  size="small"
                  icon="el-icon-delete"
                  @click="handleDdelete(scope.row)"
                >
                  删除
                </el-button>
                <el-button
                  v-show="scope.$index!==0"
                  type="primary"
                  size="small"
                  icon="el-icon-top"
                  title="上移"
                  @click="handleMove(scope,1)"
                />
                <el-button
                  v-show="scope.$index!==apptypesList.length-1"
                  type="primary"
                  size="small"
                  icon="el-icon-bottom"
                  title="下移"
                  @click="handleMove(scope,0)"
                />
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <!-- 新增编辑应用类型 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="handleTitle==='add'?'添加应用类型':'编辑应用类型'"
      width="650px"
      @close="dialogClose"
    >
      <el-form
        ref="handleForm"
        :model="handleForm"
        :rules="handleRules"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="类型名称：" prop="name">
          <el-input
            v-model="handleForm.name"
            name="name"
            maxlength="10"
            placeholder="请输入类型名称"
            class="handle-form-input"
          />
        </el-form-item>
        <el-form-item label="类型简介：" prop="introduction">
          <el-input
            v-model="handleForm.introduction"
            name="introduce"
            type="textarea"
            :rows="6"
            placeholder="请输入内容"
            class="handle-form-input"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="hiddenVariable.dialogEditVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddSubject"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { validateUserName } from '@/utils/validate';
import {
  appList,
  moveApp,
  addAppType,
  updateAppType,
  dateleAppType
} from '@/api/productOperation/wisdom/applicationType';
import { mapGetters } from 'vuex';
export default {
  name: 'WisdomApplicationType',

  data() {
    return {
      ajaxLoading: false,
      // 弹框标题
      handleTitle: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false // 添加编辑
      },
      // 搜索表单
      searchForm: {
        name: '',
        pageNum: 1,
        total: 0,
        pageSize: 10,
        typeCode: 'B12'
      },
      // 操作表单
      handleForm: {
        name: '',
        introduction: ''
      },
      handleRules: {
        name: [
          { required: true, message: '应用类型标题不能为空', trigger: 'blur' },
          { trigger: 'blur', validator: validateUserName }
        ]
      },
      listLoading: false, // 表格刷新loading
      apptypesList: []
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 学科类别
    userCode() {
      return this.userInfo.roleVOList[0].createUserCode;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.listLoading = true;
      appList(this.searchForm).then(res => {
        this.listLoading = false;
        this.apptypesList = res.data.list;
        this.searchForm.total = res.data.total;
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.init();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.init();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.init();
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.handleTitle = type;
      this.handleForm.createUserCode = this.userCode;
      this.hiddenVariable.dialogEditVisible = true;
      this.handleForm = {};
      if (type === 'edit') {
        this.handleForm = {
          name: row.name,
          introduction: row.introduction,
          id: row.id
        };
      }
    },
    dialogClose() {
      this.$refs['handleForm'].resetFields();
    },
    // 新增编辑学科
    handleAddSubject() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          if (this.handleTitle === 'add') {
            const data = {
              name: this.handleForm.name,
              introduction: this.handleForm.introduction,
              createUserCode: this.userCode,
              typeCode: 'B12'
            };
            addAppType(data)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '新增成功',
                  showClose: false,
                  duration: 2000
                });
                this.hiddenVariable.dialogEditVisible = false;
                this.ajaxLoading = false;
                this.init();
              })
              .catch(err => {
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            const data = {
              name: this.handleForm.name,
              introduction: this.handleForm.introduction,
              updateUserCode: this.userCode,
              typeCode: 'B12'
            };
            updateAppType(data, this.handleForm.id)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.hiddenVariable.dialogEditVisible = false;
                this.ajaxLoading = false;
                this.init();
              })
              .catch(err => {
                console.log(err);
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 上移下移
    handleMove(scope, type) {
      const form = {
        idOne: scope.row.id,
        idTwo: type
          ? this.apptypesList[scope.$index - 1].id
          : this.apptypesList[scope.$index + 1].id
      };
      moveApp(form)
        .then(result => {
          this.$notify.success({
            title: 'Success',
            message: '移动成功',
            showClose: false,
            duration: 2000
          });
          this.init();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 删除
    handleDdelete(row) {
      this.handleForm = {
        name: row.name,
        updateUserCode: this.userCode,
        introduction: row.introduction
      };
      this.$confirm(`确定要删除该应用类型么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return dateleAppType(this.handleForm, row.id);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.init();
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.applicationType {
  padding-bottom: 20px;
  .applicationType-main {
    .applicationType-main-contain {
      // display: flex;
      .applicationType-tree {
        width: 200px;
        margin-right: 20px;
        .filter-tree {
          font-size: 15px;
          .custom-tree-node {
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      .applicationType-list {
        position: relative;
        width: 100%;
        .searchForm{
          padding: 20px 20px 0;
        }
      }
    }
  }
}
.handle-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}
.add-type{
  position: absolute;
  right: 20px;
}
</style>
